import type { SxProps, Theme } from '@mui/material'
import { palette } from '../../../styles/material-ui/palette'
import type { StatusType } from './status-pill.types'

export const styles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 1,
    padding: '6px 16px',
    borderRadius: 8,
    fontSize: '0.875rem',
    fontWeight: 600,
    alignSelf: 'baseline',
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
  },
}

export const statusConfigs: Record<
  StatusType,
  { backgroundColor: string; textColor: string; dotColor: string; labelKey: string }
> = {
  scheduled: {
    backgroundColor: palette.alert.teal.lightest,
    textColor: palette.alert.teal.dark,
    dotColor: palette.alert.teal.dark,
    labelKey: 'statusPill.scheduled',
  },
  staged: {
    backgroundColor: palette.gray[8],
    textColor: palette.gray[64],
    dotColor: palette.gray[64],
    labelKey: 'statusPill.staged',
  },
  voided: {
    backgroundColor: palette.gray[8],
    textColor: palette.gray[64],
    dotColor: palette.gray[64],
    labelKey: 'statusPill.voided',
  },
  processing: {
    backgroundColor: palette.alert.teal.lightest,
    textColor: palette.alert.teal.dark,
    dotColor: palette.alert.teal.dark,
    labelKey: 'statusPill.processing',
  },
  requires_action: {
    backgroundColor: palette.warning.lightest,
    textColor: palette.warning.dark,
    dotColor: palette.warning.dark,
    labelKey: 'statusPill.requiresAction',
  },
  paid: {
    backgroundColor: palette.alert.successV2.lightest,
    textColor: palette.alert.successV2.dark,
    dotColor: palette.alert.successV2.dark,
    labelKey: 'statusPill.paid',
  },
  failed: {
    backgroundColor: palette.error.lightest,
    textColor: palette.error.dark,
    dotColor: palette.error.dark,
    labelKey: 'statusPill.failed',
  },
  failed_retry: {
    backgroundColor: palette.orange.lightest,
    textColor: palette.orange.dark,
    dotColor: palette.orange.dark,
    labelKey: 'statusPill.failedRetry',
  },
  failed_canceled: {
    backgroundColor: palette.gray[8],
    textColor: palette.gray[64],
    dotColor: palette.gray[64],
    labelKey: 'statusPill.failedCanceled',
  },
  canceled: {
    backgroundColor: palette.gray[8],
    textColor: palette.gray[64],
    dotColor: palette.gray[64],
    labelKey: 'statusPill.canceled',
  },
  collections: {
    backgroundColor: palette.pink.lightest,
    textColor: palette.pink.dark,
    dotColor: palette.pink.dark,
    labelKey: 'statusPill.collections',
  },
  refunding: {
    backgroundColor: palette.alert.indigo.lightest,
    textColor: palette.alert.indigo.dark,
    dotColor: palette.alert.indigo.dark,
    labelKey: 'statusPill.refunding',
  },
  refunded: {
    backgroundColor: palette.blue.lightest,
    textColor: palette.blue.dark,
    dotColor: palette.blue.dark,
    labelKey: 'statusPill.refunded',
  },
  refunding_partial: {
    backgroundColor: palette.alert.indigo.lightest,
    textColor: palette.alert.indigo.dark,
    dotColor: palette.alert.indigo.dark,
    labelKey: 'statusPill.refundingPartial',
  },
  refunded_partial: {
    backgroundColor: palette.blue.lightest,
    textColor: palette.blue.dark,
    dotColor: palette.blue.dark,
    labelKey: 'statusPill.refundedPartial',
  },
  disputing: {
    backgroundColor: palette.pink.lightest,
    textColor: palette.pink.dark,
    dotColor: palette.pink.dark,
    labelKey: 'statusPill.disputing',
  },
  active: {
    backgroundColor: palette.alert.successV2.lightest,
    textColor: palette.alert.successV2.dark,
    dotColor: palette.alert.successV2.dark,
    labelKey: 'statusPill.active',
  },
  suspended: {
    backgroundColor: palette.warning.lightest,
    textColor: palette.warning.dark,
    dotColor: palette.warning.dark,
    labelKey: 'statusPill.suspended',
  },
  membership: {
    backgroundColor: palette.blue.lightest,
    textColor: palette.blue.dark,
    dotColor: palette.blue.dark,
    labelKey: 'statusPill.membership',
  },
  service_payment: {
    backgroundColor: palette.blue.lightest,
    textColor: palette.blue.dark,
    dotColor: palette.blue.dark,
    labelKey: 'statusPill.servicePayment',
  },
  secondary_fee: {
    backgroundColor: palette.alert.indigo.lightest,
    textColor: palette.alert.indigo.dark,
    dotColor: palette.alert.indigo.dark,
    labelKey: 'statusPill.secondaryFee',
  },
  initial_payment: {
    backgroundColor: palette.alert.successV2.lightest,
    textColor: palette.alert.successV2.dark,
    dotColor: palette.alert.successV2.dark,
    labelKey: 'statusPill.initialPayment',
  },
  available: {
    backgroundColor: palette.success.lightest,
    textColor: palette.success.dark,
    dotColor: palette.success.dark,
    labelKey: 'statusPill.available',
  },
  in_use: {
    backgroundColor: palette.blue.lightest,
    textColor: palette.blue.dark,
    dotColor: palette.blue.dark,
    labelKey: 'statusPill.inUse',
  },
  dirty: {
    backgroundColor: palette.warning.lightest,
    textColor: palette.warning.dark,
    dotColor: palette.warning.dark,
    labelKey: 'statusPill.dirty',
  },
  delay: {
    backgroundColor: palette.blue.lightest,
    textColor: palette.blue.dark,
    dotColor: palette.blue.dark,
    labelKey: 'statusPill.delay',
  },
  error: {
    backgroundColor: palette.error.lightest,
    textColor: palette.error.dark,
    dotColor: palette.error.dark,
    labelKey: 'statusPill.error',
  },
  disabled: {
    backgroundColor: palette.error.lightest,
    textColor: palette.error.dark,
    dotColor: palette.error.dark,
    labelKey: 'statusPill.disabled',
  },
}
